import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { EventProperties } from '@tracking';

import Awareness from './Awareness';
import Topic from './Topic';

export enum BannerType {
  Awareness = 'awareness',
  Topic = 'topic',
}

interface StickyBannerTopProps {
  analytics?: EventProperties;
  bannerType: BannerType;
  headline: string;
  submitLink: string;
}

const queryClient = new QueryClient();

const StickyBannerTopContent = (bannerType: string) => {
  switch (bannerType) {
    case BannerType.Awareness:
      return Awareness;
    case BannerType.Topic:
      return Topic;
  }
};

const StickyBannerTop = (props: StickyBannerTopProps): JSX.Element => {
  const StickyContent = StickyBannerTopContent(props.bannerType);

  return (
    <QueryClientProvider client={queryClient}>
      <StickyContent {...props} />
    </QueryClientProvider>
  );
};

export default StickyBannerTop;
